// extracted by mini-css-extract-plugin
export default {"container":"ArrowWithCount__container___BNU3a","count":"ArrowWithCount__count___dObmY"};